// extracted by mini-css-extract-plugin
export default {"base":"vp_lXtxr","details":"vp_OuO7G","title":"vp_Wi8tr","description":"vp_x7Prg"};